import { IEntity } from "../interfaces/entity";

export class BankDetails implements IEntity {

  id: number;
  bank: string;
  bic: string;
  iban: string;
  accountHolder: string;
  sepaCheck: boolean;

  entityName = "BankDetails";

  constructor(formValue?: Partial<BankDetails>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<BankDetails>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
